<template>
    <div :class="cssClasses.pcc">
        <SpacingClassWrapper
            :padding-x="0"
            :margin-bottom="$mq | mq({ sm: 0, pccFullSize: 6 })"
        >
            <CardFormLayout @download-click="initDownload" />
        </SpacingClassWrapper>
        <SpacingClassWrapper
            :margin-bottom="0"
            :padding-x="0"
        >
            <ScrollOnEvent
                :event-instance="scrollOnCalculateInstance"
                :event-name="scrollOnCalculateEventName"
                :margin-of-error="scrollOnCalculateMarginOfError"
                :vertical-alignment="scrollVerticalAlignment.CENTER"
            >
                <ResultsSwiperLayout />
            </ScrollOnEvent>
        </SpacingClassWrapper>
    </div>
</template>
<script>

// Class Wrappers
import SpacingClassWrapper from './classWrappers/SpacingClassWrapper';

// Event Wrappers
import ScrollOnEvent from './eventWrappers/scrollOnEventWrapper';

// Layouts
import ResultsSwiperLayout from './layouts/results/ResultsSwiperLayout';
import CardFormLayout from './layouts/form/CardFormLayout';

// Mixins
import styles from './mixins/styles';
import translations from './mixins/translations';

// Types
import { scrollVerticalAlignment } from './types/ScrollOnEvent.types';

// Vuex
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapGetters } = createNamespacedHelpers('pokerChipCalcModule');

// Utils
import { downloadResults } from './utils/download-pdf-utils';

// Types
import { typographyColors, typographySizes } from './types/Typography.types';

export default {
    name: 'PokerChipCalcualtor',
    components: {
        // Class Wrappers
        SpacingClassWrapper,
        // Event Wrappers
        ScrollOnEvent,
        // Layouts
        ResultsSwiperLayout,
        CardFormLayout
    },
    mixins: [styles, translations],
    data: function () {
        return {
            // Types
            scrollVerticalAlignment,
            typographyColors,
            typographySizes
        }
    },
    computed: {
        ...mapState([
            'language',
            'currency',
            'scrollOnCalculateInstance',
            'scrollOnCalculateEventName',
            'scrollOnCalculateMarginOfError'
        ]),
        ...mapGetters([
            'dataForDownloadableDoc'
        ])
    },
    methods: {
        initDownload: function () {
            downloadResults(
                this.dataForDownloadableDoc,
                this.t,
                this.language,
                this.currency
            );
        }
    }
};
</script>
